<template>
	<c-dialog ref="dialog" width="600" mode="slide" mask-close @close="dialogFormEditConfirm($refs.salaryForm, arguments)" @resolve="editHandle">
		<c-tips v-if="freeEdition">工资绩效配置最多可创建{{systemConfig.free_salary_match_count}}条</c-tips>

		<c-form ref="salaryForm" unit-width="100%">
			<c-form-item label="计价方式" required>
				<c-radio-group name="pricing_type" v-model="pricing_type" :options="pricingTypeDic" @change="changeOutputPricingType($event)"></c-radio-group>
			</c-form-item>
			<c-form-item label="工资单价（元）" :tip="priceTip" width="200" required>
				<c-input type="stepper" name="price" decimal="6" :range="[0,99999999]" step="1"></c-input>
			</c-form-item>
			<c-form-item label="标准效率" tip="计价方式为【计时】情况下，标准单位时间内的标准产出；主要用于计算效率" :required="this.pricing_type == 2">
				<c-grid-row gap column="3">
					<c-grid-col>
						<c-input type="number" decimal="6" name="unit_duration_count" placeholder="标准产出"  :range="[0.01,99999999]" ></c-input>
					</c-grid-col>
					<c-grid-col>
						<c-input type="number" decimal="0" name="unit_duration_hours" placeholder="标准工时" :range="[0,9999]"  append-text="时"></c-input>
					</c-grid-col>
					<c-grid-col>
						<c-input type="number" decimal="0" name="unit_duration_minutes" placeholder="标准工时" :range="[0,59]" append-text="分" ></c-input>
					</c-grid-col>
				</c-grid-row>
			</c-form-item>
			<c-form-item label="备注">
				<c-input type="textarea" name="remark" maxlength="500"></c-input>
			</c-form-item>
			<c-form-item v-for="(item, i) in fieldList" :key="i" :label="item.field_title">
				<c-input v-if="item.field_type == 1"
				         type="text"
				         :name="item.field_code"
				         :placeholder="'请输入'||item.field_title"
				></c-input>

				<c-input v-else-if="item.field_type == 2"
				         type="stepper"
				         step="1"
				         :name="item.field_code"
				         decimal="6"
				         :placeholder="'请输入'||item.field_title"
				></c-input>

				<template v-else-if="item.is_custom  == 1 && item.config_json.type == 'option'">
					<template v-if="item.config_json.mode == 'option'">
						<c-checkbox-group v-if="item.config_json.attr.includes('multiple')"
						                  :name="item.field_code"
						                  :options="item.config_json.options"
						></c-checkbox-group>

						<c-radio-group v-else
						               :name="item.field_code"
						               :options="item.config_json.options"
						></c-radio-group>
					</template>

					<c-select v-else
					          :name="item.field_code"
					          :options="item.config_json.options"
					          multiple
					          :placeholder="item.config_json.placeholder || '请选择'"
					></c-select>
				</template>

				<template v-else-if="item.is_custom  == 0 && item.field_type == 4">
					<c-select v-if="item.config_json.dict_config.dictType == 'DBDIC'"
						      :name="item.field_code"
						      async
						      @search="searchDBOptions(item.config_json.dict_config.dictName, arguments[0], arguments[1])"
						      :value-data="item.options"
					          :multiple="{linefeed: true}"
					></c-select>

					<c-select v-else
						      :name="item.field_code"
					          :options="item.options"
					          multiple
					></c-select>
				</template>

			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
import {mapState, mapGetters} from "vuex";
import dictList from "@/store/dict";

export default {
	name: 'salaryConfigEdit',
	computed: {
		// 获取dictName选项数据
		...mapState(['pricingTypeDic','systemConfig']),
		...mapGetters(['freeEdition'])
	},
	// 监听器
	watch: {
		id() {
			this.getDetail();
		}
	},
	mounted() {
		if (this.id){
			//查询产品详情
			this.getDetail();
		}
	},
	data() {
		return {
			fieldList:[],
			editState:false,
			copyState:false,
			salary_match_config_id:0,
			pricing_type:1, //计价方式（1：计件，2：计时）
			priceTip:'表示完成一件产品可以获得的工资金额'
		}
	},
	methods: {
		/**
		 * 打开新增、编辑弹窗
		 * @param data          数据
		 * @param type          类型 1=新增
		 *                          2=编辑
		 *                          3=复制
		 */
		async open(data,type) {
			this.salary_match_config_id = 0;
			this.editState = !!data;
			if (!this.editState && !(await this.checkDataCount('SALARY_MATCH_CONFIG')).data) return;
			if (type && type==3){
				this.copyState = true;
			}else {
				this.copyState = false;
			}
			this.$refs.salaryForm.clear();
			if (data && !this.copyState){
				this.salary_match_config_id = data.id;
			}else {
				this.salary_match_config_id = 0;
			}
			//加载动态数据列信息
			this.loadCustomField(data);
			//填充form表单
			var title = data ? '编辑绩效工资配置' : '新增绩效工资配置';
			if (this.copyState){
				title = "复制绩效工资配置";
			}
			this.$refs.dialog.open({
				title: title
			});
		},

		/******回填Form表单*******/
		setForm(data){
			if (data) {
				this.getDetail(data.id||0);
			}else {
				this.$refs.salaryForm.set({
					pricing_type:this.pricing_type,
					price:0
				});
			}
		},
		/************************************/

		loadCustomField(params){
			var config_id= 0;
			if (params && params.id){
				config_id= params.id;
			}
			this.request({
				url: '/salary/match/config/field_list',
				data: {
					config_id: config_id
				},
				success: data => {
					this.fieldList = data||[];
					this.fieldList.map(field => {
						if (field.is_custom  == 0 && field.field_type == 4) {
							if (field.config_json.dict_config.dictType == 'PAGEDIC') {
								this.$set(field, 'options', dictList[field.config_json.dict_config.dictName]);
							}
							/*else if (field.config_json.dict_config.dictType == 'DBDIC') {
								this.request({
									url: '/system/options',
									data: {
										options_code: field.config_json.dict_config.dictName
									},
									success: data => {
										this.$set(field, 'options', data);
									}
								});
							}*/
						}
					});
					this.$nextTick(()=>{
						this.setForm(params);
					});
				}
			});
		},

		/*******部分系统下拉框数据，异步加载*****************/
		searchDBOptions(options_code,keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:options_code,
					keyword:keyword
				},
				success:data => {
					resolve(data);
				}
			});
		},
		/**
		 * 加载详情信息
		 */
		getDetail(id) {
			this.request({
				url:'/salary/match/config/detail',
				data: {
					id: id
				},
				loading: true,
				success: data => {
					this.$refs.salaryForm.set(data);
				}
			});
		},

		/********【变更】报工计价方式*************/
		changeOutputPricingType(selectData){
			this.pricing_type = selectData;
			if (this.pricing_type == 1){//计件
				this.priceTip = '表示完成一件产品可以获得的工资金额';
			}else {//计时
				this.priceTip = '表示工作1小时可以获得的工资金额';
			}
		},

		/*******提交编辑数据********************/
		editHandle(stop, next) {
			stop();
			this.$refs.salaryForm.submit({
				url: 'salary/match/config/edit',
				rule: {
					pricing_type: '请选择计价方式',
					price: data => {
						if(!data.price) return "请输入工资单价";
						// if (data.price<=0) {
						// 	return '工资单价金额必须大于0';
						// }
						return true;
					},
                    unit_duration_count: data => {
                        if (this.pricing_type == 2){
                            if (!data.unit_duration_count
                                || (!data.unit_duration_hours && !data.unit_duration_minutes)
                                || (parseInt(data.unit_duration_hours||0)+parseInt(data.unit_duration_minutes||0))<=0
                            ) {
                                return '请完善标准效率信息';
                            }else if (parseInt(data.unit_duration_count||0)<=0) {
                                return '标准产出数量必须大于0';
                            }
                        }
                        return true;
                    }
				},
				dataFormatter: data => {
					data.id = this.salary_match_config_id||0;
					data.pricing_type = this.pricing_type||1;
					return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						message:this.editState ? '编辑成功' : '创建成功',
					});
					//刷新配置列表
					this.$bus.$emit('salary_match_config.list.update', {});
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
</style>